<script>
import { mapGetters } from 'vuex'
import * as userMutations from '@/store/modules/users/mutations'
export default {
    // @TODO: Cég és gépjármű listázó implementálása

    data() {
        return {
            model: {
                locale: 'hu',
            },
            selectedLanguages: null,
        }
    },

    computed: {
        ...mapGetters({ languages: 'languages' }),
    },

    mounted() {
        this.$store.commit(userMutations.UPDATE_USER, { data: [] })
        this.$store.dispatch('title', this.$t('USERS.CREATE'))
    },

    methods: {
        save() {
            this.$store.dispatch('usersCreate', this.model).then(() => {
                this.$router.go(-1)
            })
        },
    },
}
</script>

<template lang="pug">
acrm-panel
    acrm-heading(:level="5") {{ $t('USERS.PERSONAL_DATA')}}
    .row
        .col-24.col-md-12.col-lg
            acrm-input-line(v-model="model.lastname") {{ $t('USERS.LASTNAME') }}
        .col-24.col-md-12.col-lg
            acrm-input-line(v-model="model.firstname") {{ $t('USERS.FIRSTNAME') }}
        .col-24.col-md-12.col-lg
            acrm-input-line(type="email" v-model="model.email") {{ $t('USERS.EMAIL') }}
        .col-24.col-md-12.col-lg
            acrm-input-phone(v-model="model.phone") {{ $t('USERS.PHONE') }}

    acrm-heading(:level="5") {{ $t('USERS.OTHER_SETTINGS')}}
    .row
        .col-24.col-md-12.col-lg
            acrm-input-line(v-model="model.type") {{ $t('USERS.TYPE') }}
        .col-24.col-md-12.col-lg
            acrm-multi-select(
                slot="edit"
                v-model="selectedLanguages"
                :multiple="true"
                :options="languages"
                option-label="translated"
                :placeholder="$t('USERS.CHOOSE')"
                track-by="id"
                @input="model.languages = selectedLanguages"
                ) {{ $t('USERS.LANGUAGES')}}
        .col-24.col-md-12.col-lg
            acrm-multi-select(
                slot="edit"
                :options="['hu', 'en']"
                :placeholder="$t('USERS.CHOOSE')"
                v-model="model.locale"
                ) {{ $t('USERS.SYSTEM_LANGUAGES')}}
        .col-24.col-md-12.col-lg
            acrm-input-line(v-model="model.nt") {{ $t('USERS.NT') }}
    .row
        .col-24.col-lg-12
            acrm-text-area(:rows="6" v-model="model.comment") {{ $t('USERS.COMMENT') }}

    template(v-if="false")
        acrm-heading.mt-2(:level="5") {{ $t('USERS.ADD_COMPANY') }}
        p {{ $t('USERS.ADD_COMPANY_HELP') }}
        .row.mb-4
            .col-24.col-sm.col-lg-12.col-xl-10
                acrm-multi-select.mb-3.mb-sm-0(
                :options="[12,3,3,]"
                :placeholder="$t('USERS.ADD_CAR_HINT')"
                ) {{ $t('USERS.ADD_CAR') }}
            .col-24.col-sm-auto.d-flex
                acrm-input-button.align-self-end(block icon="add") {{ $t('BASE.ADD') }}

        acrm-heading.mt-5(:level="5") {{ $t('USERS.ADD_CAR_1') }}
        p {{ $t('USERS.ADD_CAR_1_HELP') }}
        .row.mb-4
            .col-24.col-sm.col-lg-12.col-xl-10
                acrm-multi-select.mb-3.mb-sm-0(
                :options="[12,3,3,]"
                :placeholder="$t('USERS.ADD_CAR_HINT')"
                ) {{ $t('USERS.ADD_CAR') }}
            .col-24.col-sm-auto.d-flex
                acrm-input-button.align-self-end(block icon="add") {{ $t('BASE.ADD') }}

    hr
    .row
        .col-12.col-md-auto.ml-auto
            acrm-input-button.block-md-down(variant="light" @click="$router.go(-1)") {{ $t('BASE.BACK')}}
        .col-12.col-md-auto
            acrm-input-button.block-md-down(variant="success" @click="save") {{ $t('BASE.CREATE')}}
</template>
